import { useState } from 'react';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import SearchBar from './common/SearchBar';

import { MEDIA_URL } from "../Context";
import default_photo from '../img/default_photo.png'


function ProductCard({id, nomenclature, price, selected, photo, photo_preview, onClick}){
  const media_url = useContext(MEDIA_URL);

  // номенклатуры ВНУК
  if (nomenclature.type === "ВНУК") {
    price = price + nomenclature.base_price;
    //console.log('ВНУК');
  }

  return(
    <div className="card m-3 product-card">
      <div className="card-body">
        <div className="row">
          <div className="col-2">
            <img src={photo_preview ? media_url + photo_preview : default_photo} alt="Product" className="" width="130" height="130"></img>
          </div>
          <div className="col-7">
              <div className="card-title"> 
                <Link className="" to={`/product/` + id}>
                  <h5 className="my-2">{nomenclature.catalog_entry.catalog_number}</h5>
                </Link>   
              </div>
            <p>{nomenclature.name}</p>
          </div>
          <div className="col-3">
            <p className='position-absolute top-0 end-0 m-4'><b>{price}</b> рублей</p> 
            <div className='position-absolute bottom-0 end-0 m-4'>
              {selected === true ? 
                <button className="lk-button lk-button-disabled">В корзине</button> : 
                <button className="lk-button" onClick={onClick}>Добавить в корзину</button>
              }
            </div>
          </div>
        </div>

      </div>    
    </div> 
  );
  }


export default function Category({categories, goodsList, addProductClick, selectedYear}) {

  const [searchText, setSearchText] = useState('');
  const [showDigital, setShowDigital] = useState(true);
  let { categoryId } = useParams();
  categoryId = Number(categoryId);
  let categoryName = "";

  for (let v in categories){
    if (categories[v].id === categoryId){
      categoryName = categories[v].category_name;
      break;
    }
  }

  let rows = [];
  for(let i in goodsList) {

    if (goodsList[i].nomenclature.category === categoryId) {

      let digital = goodsList[i].nomenclature.catalog_entry.catalog_number.toLowerCase().indexOf(".1") === -1
      if (showDigital === true) {
        if (digital) {
          //pass
        } else {
          continue;
        }
      } else {
        if (digital) {
          continue;
        } else {
          //pass
        }        
      }

      if ((goodsList[i].nomenclature.name.toLowerCase().indexOf(searchText.toLowerCase()) === -1) &&
      goodsList[i].nomenclature.catalog_entry.catalog_number.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
        //pass
      } else {
        rows.push(
          <ProductCard
            key={goodsList[i].id} 
            id={goodsList[i].id} 
            nomenclature={goodsList[i].nomenclature}
            price={goodsList[i].price}
            selected={goodsList[i].selected}
            photo={goodsList[i].nomenclature.catalog_entry.photo}
            photo_preview={goodsList[i].nomenclature.catalog_entry.photo_preview}
            onClick={() => addProductClick(goodsList[i].id)}
          />
        );
      }
    }    
  }

  return(
    <>
      <div className="row">
        <h3 className="m-3"><Link className="lk-link" to={`/`}> Каталог {selectedYear}</Link></h3>
        <p className="ms-3 fsvok3-t">{categoryName}</p>
      </div>
      <div className="ms-3 btn-toolbar justify-content-between" style={{width: "1000px"}} role="toolbar">
        <SearchBar
          key="SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
        {showDigital === true ? 
          <div className='btn-group'>
            <div className="d-flex align-items-center fsvok3-t">выберите:</div>
            <button className="lk-toggle-left lk-button lk-button-disabled ms-4">Электронный вариант</button> 
            <button className="lk-toggle-right lk-button" onClick={() => setShowDigital(false)}>Бумажный вариант</button>
          </div> : 
          <div className='btn-group'>
            <div className="d-flex align-items-center fsvok3-t">выберите:</div>
            <button className="lk-toggle-left lk-button ms-4" onClick={() => setShowDigital(true)}>Электронный вариант</button> 
            <button className="lk-toggle-right lk-button lk-button-disabled">Бумажный вариант</button> 
          </div>
        }
      </div>   
      {rows} 
    </>
  );
}
  